import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-liquidaciones-page',
    imports: [RouterOutlet],
    templateUrl: './liquidaciones-page.component.html',
    styleUrl: './liquidaciones-page.component.scss'
})
export class LiquidacionesPageComponent {} 